import React, { useEffect, useState } from 'react';
import { Button, ButtonToolbar, Modal, Table } from 'reactstrap';
import { Field } from 'redux-form';
import renderSelectField from '../../../../shared/components/form/Select';
import renderRadioButtonField from '../../../../shared/components/form/RadioButton';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from '@material-ui/core';
import { faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../../shared/components/Modal';


const AddFileAdmision = ({
    open, toggle,archivo, uploadFile
}) => {
    

const [formFiles, setFormFiles] = useState([])
const [errors, setErrors] = useState([])
const [showAlertModal, setShowAlertModal] = React.useState(false);
const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
const [colorAlertModal, setAlertColorModal] = React.useState("info");
const [selectFile, setSelectFile] = useState(null)


useEffect(()=>{
    if (archivo != null){
        setFormFiles([...archivo].map((value, key) => (
            {
                file: value,
                documentClass: null,
                description:"",
                typeImg:""
            }
        )))
    }

},[archivo])

function changesFormState(index, attribute, value) {
    setFormFiles([...formFiles].map((object, idx) => {
        if(idx === index) {
          return {
            ...object,
            [attribute]:value
          }
        }
        else return object;
    }))
}

    const confirmDeleteFile = async () => {
        setShowAlertModal(false);
        setAlertColorModal("info");
        setAlertMessageModal("");

        console.log(selectFile);

        const filterData = formFiles.filter((formFile, index) => selectFile !== index);
        setFormFiles(filterData)
    }

    const validate = () => {
        var errors = [];
        const validateItem = (formFile) => {
            let error = 0;
            let errorObject = {}
            /* if (formFile.description == "") {
                errors.description = "Ingrese una descripción al archivo";
                error ++;
            } else {
                errors.description = "";
            } */
    
            if (formFile.typeImg == "") {
                errorObject.typeImg = "Seleccione un tipo de imagen";
                error ++;
            } else {
                errorObject.typeImg = "";
            }    
            if (formFile.documentClass == null) {
                errorObject.documentClass = "Seleccione una clase";
                error ++;
            } else {
                errorObject.documentClass = "";
            }
            errors.push(errorObject)
            return error === 0
        }

        const validation = formFiles.every(validateItem)
        setErrors(errors)
        return validation
    }

function handleUpload() {
    console.log(formFiles);
    if(validate()){
        uploadFile(formFiles)
        toggle()    
    }

}

const optionsFile = () => {
    let tipos = JSON.parse(sessionStorage.getItem('centroTipos'));
    if(tipos.includes('3')) //IPS Nuclear 
    {
        let dataOpt = [
            { value: 1, label: 'CONSENTIMIENTO INFORMADO' },
            { value: 2, label: 'ECOCARDIOGRAMA MODO M' },
            { value: 3, label: 'ECOCARDIOGRAMA STRESS' },
            { value: 4, label: 'ELECTROCARDIOGRAMAS' },
            { value: 5, label: 'FORMULA MEDIACA' },
            { value: 6, label: 'HISTORIA CLINICA' },
            { value: 7, label: 'HOLTER CARDIACO' },
            { value: 8, label: 'IMAGENOLOGIA' },
            { value: 9, label: 'LABORATORIO CLINICO' },
            { value: 10, label: 'MONITOREO DE PRESION ARTERIAL' },
            { value: 11, label: 'ORDEN MEDICA' },
            { value: 12, label: 'GAMAGRAFIAS' },
            { value: 13, label: 'RESONANCIA NUCLEAR MAGNETICA' },
            { value: 14, label: 'DOCUMENTO DE IDENTIDAD' },
            { value: 15, label: 'AUTORIZACION' },
            { value: 16, label: 'OTROS' },
        ];

        return dataOpt;
    }
    else //IPS Clinica
    {
        let dataOpt = [
            { value: 1, label: 'CONSENTIMIENTO INFORMADO' },
            { value: 2, label: 'ECOCARDIOGRAMA MODO M' },
            { value: 3, label: 'ECOCARDIOGRAMA STRESS' },
            { value: 4, label: 'ELECTROCARDIOGRAMAS' },
            { value: 5, label: 'FORMULA MEDIACA' },
            { value: 6, label: 'HISTORIA CLINICA' },
            { value: 7, label: 'HOLTER CARDIACO' },
            { value: 9, label: 'LABORATORIO CLINICO' },
            { value: 10, label: 'MONITOREO DE PRESION ARTERIAL' },
            { value: 11, label: 'ORDEN MEDICA' },
            { value: 14, label: 'DOCUMENTO DE IDENTIDAD' },
            { value: 15, label: 'AUTORIZACION' },
            { value: 16, label: 'OTROS' },
        ];

        return dataOpt;
    }
};

  return (
        <Modal
            isOpen={open}
            toggle={toggle} 
            centered
            size="lg" style={{minWidth: '1200px', minHeight:'400', width: '70%'}}
        >
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <div>
                <Table style={{  width: '100%' }} responsive>
                    <thead>
                        <tr>
                            <th>Archivo</th>
                            <th>Clase de documento</th>
                            <th>Descripción</th>
                            <th>Tipo de imagen</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {          
                            formFiles.map((value, index)=>(
                                <tr key={index}>
                                    <td>
                                        <div className='form__form-group' style={{marginTop:10}}> {value.file.name}</div>
                                    </td>
                                    <td>
                                        <div className="form__form-group">
                                            <div className="form__form-group-field">
                                                <Field
                                                    name={`select${index}`}
                                                    component={renderSelectField}
                                                    style={{position:'relative', zIndex:-1400}}
                                                    value={value.documentClass}
                                                    onChange={(event) => {
                                                        changesFormState(index, 'documentClass', event)
                                                    }} 
                                                    options={optionsFile()}
                                                />
                                            </div>
                                            <span className="form__form-group-label" style={{ color: 'red' }}>
                                                {errors[index]?.hasOwnProperty("documentClass") ? errors[index]?.documentClass : ""}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="form__form-group-field" style={{justifyContent:'center'}}>
                                            <Field
                                                name={`textarea-description${index}`}
                                                component="textarea"
                                                type="text"
                                                value={value.description}
                                                onChange={(e) => {
                                                    changesFormState(index, 'description', e.target.value)
                                                }}
                                            />
                                        </div>
                                    </td>
                                    <td>
                                        <div className="form__form-group">

                                            <div className="form__form-group-field" style={{display: 'flex', justifyContent:"space-around"}}>
                                                    <Field
                                                        name={`radio_button-candiate${index}`}
                                                        component={renderRadioButtonField}
                                                        label="INSTITUCIONAL"
                                                        radioValue={"institucional"}
                                                        //defaultChecked={this.props.anamesis.candidate}
                                                        onChange={(e) => {
                                                            changesFormState(index, 'typeImg', e)
                                                        }}
                                                    />
                                                    <Field
                                                        name={`radio_button-candiate${index}`}
                                                        component={renderRadioButtonField}
                                                        label="EXTRAINSTITUCIONAL"
                                                        radioValue={"extrainstitucional"}
                                                        //defaultChecked={!this.props.anamesis.candidate}
                                                        onChange={(e) => {
                                                            changesFormState(index, 'typeImg', e)
                                                            //this.props.handlerCandidate(e);
                                                        }}
                                                    />
                                            </div>
                                            <span className="form__form-group-label" style={{ color: 'red' }}>
                                                {errors[index]?.hasOwnProperty("typeImg") ? errors[index]?.typeImg : ""}
                                            </span>
                                        </div>                           
                                    </td>
                                    <td>
                                        <Tooltip title="Eliminar Archivo">
                                            <IconButton aria-label="unable" style={{ padding: 2 }}
                                            onClick={() => {
                                                setSelectFile(index)
                                                setAlertColorModal("warning");
                                                setAlertMessageModal("Esta seguro que desea eliminar este archivo?");
                                                setShowAlertModal(true);

                                            }}>
                                                <FontAwesomeIcon icon={faTrashAlt} style={{ margin: '0px 5px 0px 5px', width: 20 }} />
                                            </IconButton>
                                        </Tooltip>
                                        <AlertModal
                                            color={colorAlertModal}
                                            title={messagAlerteModal}
                                            modal={showAlertModal}
                                            onOk={() => {
                                            switch (colorAlertModal) {
                                                case 'success':
                                                setShowAlertModal(false);
                                                setAlertColorModal("info");
                                                setAlertMessageModal("");
                                                Callback();
                                                break;
                                                case 'warning':
                                                confirmDeleteFile();
                                                break;
                                                case 'danger':
                                                setShowAlertModal(false);
                                                setAlertColorModal("info");
                                                setAlertMessageModal("");
                                                break;
                                            }
                                            }}
                                            toggle={() => {
                                            setShowAlertModal(false);
                                            switch (colorAlertModal) {
                                                case 'success':
                                                setAlertColorModal("info");
                                                setAlertMessageModal("");
                                                Callback();
                                                break;
                                            }
                                            }}
                                        />
                                    </td>
                                </tr>                              
                             ))                                                         
                        }                        
                    </tbody>    
                </Table>
            </div>
           
            <ButtonToolbar className="modal__footer">
                <Button className="modal_cancel" onClick={toggle}>Cancelar</Button>{' '}
                <Button className="modal_ok" color="primary" onClick={handleUpload}>Confirmar documento</Button>
            </ButtonToolbar>
        </Modal>
  );
};

export default AddFileAdmision